import { createContext, useContext } from "react";
const SheetViewportContext = createContext(null);
export const SheetViewportProvider = SheetViewportContext.Provider;
export function useSheetViewport() {
    return useContext(SheetViewportContext);
}
//# sourceMappingURL=SheetViewportContext.js.map